export const CONTENT_TYPES = [
  { id: 'course', name: 'course' },
  { id: 'university', name: 'university' },
  { id: 'scholarship', name: 'scholarship' },
  { id: 'quizBundle', name: 'quizBundle' },
  { id: 'quiz', name: 'quiz' },
  { id: 'post', name: 'post' },
  { id: 'live_streaming', name: 'live_streaming' },
];
